// src/polaris-components/RequireAuth.tsx
import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { unauthorizedLoginPath } from '../utils/loginRedirect';

export default function RequireAuth() {
    const location = useLocation();
    const parentContext = useOutletContext();
    const { isAuthenticated, isLoading, userInfo } = useAuth();

    // Allow /add-admin-profile without auth when coming from invitation
    if (location.pathname === '/add-admin-profile' && location.state?.fromInvitation) {
        return <Outlet context={parentContext} />;
    }

    // Show loading state while checking authentication
    if (isLoading) {
        return <div>Loading...</div>;
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated || !userInfo) {
        return <Navigate to={unauthorizedLoginPath(location)} replace />;
    }

    return <Outlet context={parentContext} />;
}

